'use strict';

var StrategyTemplateThumbnailDirective = function StrategyTemplateThumbnailDirective() {
  return {
    restrict: 'E',
    replace: true,
    require: '^rmStrategyTemplatesPanel',
    template: require('../templates/strategy-template-thumbnail.html'),
    scope: {
      strategyTemplate: '='
    }
  };
};
StrategyTemplateThumbnailDirective.$inject = [];
module.exports = StrategyTemplateThumbnailDirective;